<template>
    <div class="">
        <help-modal/>
        <div class="ibox">
            <div class="ibox-title ibox-grey">
                <h4>{{ formLabel }} </h4>
                <div class="ibox-tools">
                    <button-open-help-modal :helpName="'UAI-001'" :inExtraDiv="false"/>
                </div>
            </div>

            <div class="ibox-content">
                <div class="form row">
                    <div class="col-md-2" v-if="action != 'show'">
                        <label>{{ __('price_list_type')}}*</label>
                        <Select2
                          :disabled="action == 'edit' || action == 'refill' || tariffs_store.length > 0"
                          name="type"
                          :settings="{ width: '100%' }"
                          v-model="price_list_model.type"
                          :options="price_list_types"
                          @change="changeType($event)"
                          @blur="$v.price_list_model.type.$touch()"/>
                          <span class="help-block text-danger" v-for="error in tariffTypeErrors">{{error}}</span>
                    </div>

                    <div class="col-md-2" v-if="price_list_model.type == 'standard'" :class="{'d-none' : read_only && ( price_list.country_id == '' || price_list.country_id == null)}">
                        <label>{{ __('country')}}*</label>
                        <Select2
                          :disabled="action == 'show' || action == 'edit' || action == 'refill'"
                          name="country"
                          :settings="{ width: '100%' }"
                          v-model="price_list_model.country_id"
                          :options="country_select"
                          ref="price_list_country"
                          @change="changeCountry()"
                          />
                          <span class="help-block text-danger" v-for="error in tariffCountryErrors">{{error}}</span>
                    </div>

                    <div class="col-md-2"
                         v-if="price_list_model.type !== 'standard'"
                      :class="{'d-none' : read_only && (price_list.name == '' || price_list.name == null)}">
                        <label>{{ __('name_obj')}}*</label>
                        <input
                          type="text"
                          name="name"
                          class="form-control"
                          v-model="price_list_model.name"
                          :disabled="action=='show' || action=='edit' || action =='refill'"
                         />
                          <span class="help-block text-danger" v-for="error in tariffNameErrors">{{error}}</span>
                    </div>

                    <div class="col-md-2">
                        <label>{{ __('currency')}}*</label>
                        <Select2
                            v-if="price_list_model.type != 'mother'"
                            name="currency"
                            v-model="price_list_model.currency_id"
                            :options="currency_select"
                            :disabled="action=='show' || action=='edit' || action =='refill'"
                            required="required"
                            :settings="{ width: '100%' }"/>
                        <input
                            v-else
                            type="text"
                            name="currency"
                            class="form-control"
                            v-model="price_list_model.currency_id"
                            :disabled="true"
                        />
                          <span class="help-block text-danger" v-for="error in tariffCurrencyErrors">{{error}}</span>
                    </div>
                    <div class="col-md-2" v-if="(price_list_model.type == 'standard' || price_list_model.type == 'special') && superadmin_view == 1">
                        <label>{{ __('price_list_mother')}}*</label>
                        <Select2
                            name="mother_id"
                            :settings="{ width: '100%' }"
                            v-model="price_list_model.mother_id"
                            :disabled="mother_and_exchange_rate_disabled || action=='show' || (action=='edit' && mother_and_exchange_rate_disabled) || (action =='refill'  && mother_and_exchange_rate_disabled)"
                            :options="motherPriceListOptions"/>
                        <span class="help-block text-danger" v-for="error in tariffMotherIdErrors">{{error}}</span>
                    </div>
                    <div class="col-md-2" v-show="price_list_model.type == 'standard' || price_list_model.type == 'special'">
                        <label>{{ __('points_exchange_2')}}*</label>
                        <input
                            type="text"
                            name="exchange_rate"
                            class="form-control exchange-rate text-right"
                            v-model="price_list_model.exchange_rate"
                            :disabled="action=='show' || (action=='edit' && mother_and_exchange_rate_disabled) ||( action =='refill' && (action =='refill'  && mother_and_exchange_rate_disabled)) "
                            :readonly="mother_and_exchange_rate_disabled"
                            @change="handleExchangeRateChanged"/>

                        <span class="help-block text-danger" v-for="error in exchangeRateErrors">{{error}}</span>
                    </div>
                    <div class="col-md-2">
                        <label>{{ __('valid_from_date')}}*</label>
                        <div class="input-group date col-12 p-0 m-0">
                            <datepicker
                              class="col-12 p-0 m-0"
                              name="date_from"
                              v-model="price_list_model.date_from"
                              :start_date="startDate"
                              :min_date="startDate"
                              :options="getDatePickerOptions"
                              :disabled="action=='show' || action == 'edit' || action =='refill'"
                             />
                              <span class="help-block text-danger" v-for="error in tariffDateFromErrors">{{error}}</span>
                        </div>
                    </div>

                    <div class="col-md-2" v-if="action == 'create' || action == 'copy' || ((action == 'edit' && value.complete == 1) || action == 'edit' && value.has_child == false && value.complete == 0) ">
                        <button
                          v-if="price_list_model.type == 'mother'"
                          type="button"
                          class="btn btn-primary m-t"
                          @click="showModal()">
                            <i class="fa fa-plus"></i> {{ __('add_tariff_type')}}
                        </button>
                        <button
                            v-if="((price_list_model.type == 'standard' || price_list_model.type == 'special') && action != 'edit') && tariffs_store.length == 0"
                            type="button"
                            :disabled="!price_list_model.mother_id || !price_list_model.exchange_rate"
                            class="btn btn-primary m-t"
                            @click="addTariffClicked">
                            <i class="fa fa-plus"></i> {{ __('add_tariff')}}
                        </button>
                        <button @click="destroyTariffs()" v-if="(action == 'create' || action == 'copy') && (price_list_model.type == 'standard' || price_list_model.type == 'special') && tariffs_store.length > 0" class="btn btn-danger m-t">{{ __('remove_tariff')}}</button>

                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Select2 from 'v-select2-component'
import Utils from './../../services/Utils.js';
import { required, minLength, maxLength, requiredIf, minValue, maxValue } from 'vuelidate/lib/validators'
import {mapGetters} from "vuex";
import {Money} from "../../services/Money";
import HelpModal from "../help/HelpModal.vue";
import ButtonOpenHelpModal from "../help/ButtonOpenHelpModal.vue";
 function nameExists(value) {
     if(this.action == 'edit'){
         return true;
     }
    if(this.price_list_model.type == 'special' || this.price_list_model.type == 'mother') {
      return this.validationDuplicate(value, this.price_lists) == undefined;
    }
    return true;
  }
function validateExchangeRate() {
    if (this.price_list_model.type == 'mother' || this.money.toFloat(this.price_list_model.exchange_rate) <= 9999999999.9999) {
        return true;
    } else {
        return false;
    }
}
function validateMotherId() {
    if (this.price_list_model.type != 'mother') {
        return this.price_list_model.mother_id  > 0;
    } else {
        return true;
    }
}
export default {
  data : () => ({
      price_list_type : '',
      country : '',
      country_select : [],
      currency : '',
      currency_select : [],
      price_lists : [],
      price_lists_names : [],
      form_min_date : '',
      price_list: {},
      price_list_model: {},
      money: new Money(),
      mother_and_exchange_rate_disabled:false,
  }),
  validations : {
        price_list_model:{
            type : {
              required
            },
            country_id : {
              required : requiredIf(function (element){
                return element.type == 'standard'
              })
            },
            name : {
              required : requiredIf(function (element){
                return element.type == 'special' || element.type == 'mother'
              }),
              unique_name : nameExists,
              maxLength: maxLength(50)
            },
            currency_id : {
              required :requiredIf(function (element){
                  return element.type !== "mother"
              }),
            },
            date_from : {
              required
            },
            mother_id:{
                required : requiredIf(function (element){
                    return element.type == 'special' || element.type == 'standard'
                }),
                validateMotherId: validateMotherId
            },
            exchange_rate:{
                required : requiredIf(function (element){
                    return element.type == 'special' || element.type == 'standard'
                }),
                validateExchangeRate: validateExchangeRate
            }
        }
  },
  components : {
    Select2,
      HelpModal,
      ButtonOpenHelpModal
  },
  props : {
    type: String,
    read_only : Boolean,
    edit: Boolean,
    superadmin_view:Number,
    route_price_list_index_json : String,
    countries : Array,
    currencies : Array,
    price_list_types : Array,
    mother_price_list: Array,
    action: String,
    value : {
      type : Object,
      default : function () {
          return {
              type : '',
              country_id : '',
              name : '',
              currency_id : '',
              date_from : '',
              mother_id: 0,
              exchange_rate : ""
          }
      }
    },
  },
  computed : {
      ...mapGetters({tariffs_store : 'getTariffsData'}),
      motherPriceListOptions:function (){
          let options = [];
          options.push({id:0, text:'---'})
          this.mother_price_list.forEach(function (item){
              options.push({id:item.id, text:item.name})
          })
          return options
      },
    tariffTypeErrors : function () {
      const errors = [];
      if (!this.$v.price_list_model.type.$dirty) {
        return errors;
      }
      !this.$v.price_list_model.type.required && errors.push(this.__("field_price_list_type_is_required"));

      return errors;
    },
    tariffCountryErrors : function () {
      const errors = [];
      if (!this.$v.price_list_model.country_id.$dirty  || this.price_list_model.type == 'special') {
        return errors;
      }
      !this.$v.price_list_model.country_id.required && errors.push(this.__("field_country_is_required"));

      return errors;
    },
    tariffNameErrors : function () {
      const errors = [];
      if (!this.$v.price_list_model.name.$dirty || (this.price_list_model.type == 'standard')) {
        return errors;
      }
      !this.$v.price_list_model.name.required && errors.push(this.__("field_name_is_required"));
      !this.$v.price_list_model.name.unique_name && errors.push(this.__("price_list_with_that_name_already_exists"));
      !this.$v.price_list_model.name.maxLength && errors.push(this.__("price_lists_name_max_lenght_error"));

      return errors;
    },

    tariffCurrencyErrors : function () {
      const errors = [];
      if (!this.$v.price_list_model.currency_id.$dirty) {
        return errors;
      }
      !this.$v.price_list_model.currency_id.required && errors.push(this.__("field_currency_is_required"));

      return errors;
    },
      tariffMotherIdErrors : function () {
          const errors = [];
          if (!this.$v.price_list_model.mother_id.$dirty) {
              return errors;
          }
          !this.$v.price_list_model.mother_id.required && errors.push(this.__("field_mother_is_required"));
          !this.$v.price_list_model.mother_id.validateMotherId && errors.push(this.__("field_mother_is_required"));
          return errors;
      },
      exchangeRateErrors : function () {
          const errors = [];
          if (!this.$v.price_list_model.exchange_rate.$dirty) {
              return errors;
          }
          !this.$v.price_list_model.exchange_rate.required && errors.push(this.__("field_exchange_points_is_required"));
          !this.$v.price_list_model.exchange_rate.validateExchangeRate && errors.push(this.__("field_exchange_points_max"));
          return errors;
      },

    tariffDateFromErrors : function () {
      const errors = [];
      if (!this.$v.price_list_model.date_from.$dirty) {
        return errors;
      }
      !this.$v.price_list_model.date_from.required && errors.push(this.__("field_is_required"));
      return errors;
    },

    isSetPriceList : function () {
      return this.price_list.id != '';
    },

    date_from_format : function() {
      return this.price_list.date_from ? moment(this.price_list.date_from).format('YYYY-MM-DD') : null;
    },
      getDatePickerOptions : function() {
          let date = this.form_min_date;
          return {
              todayBtn: "linked",
              format: "yyyy-mm-dd",
              // todayHighlight: true,
              disabled: this.action =='show' || this.action == 'edit' || this.action == 'refill',
              language : 'de-DE',
              value: date,
              startView: 0,
              startDate: moment(this.form_min_date).format('YYYY-MM-DD'),
          }
      },
    formLabel: function() {
      if(this.action == 'create') return this.__('add_new_price_list')
      else if(this.action == 'copy' ) return this.__('copy_price_list')
      else if(this.action == 'show' ) return this.__('preview_price_list')
      else if(['refill', 'edit'].includes(this.action)) return this.__('edit_price_list')
      return ''
    },
      startDate:function (){
          return moment(this.form_min_date).format('YYYY-MM-DD');
      }
  },
  watch : {
    price_list_model : {
      deep : true,
      handler(val) {
        this.$emit('input', val);
      }
    }
  },
  methods : {

      addTariffClicked(){
          this.$emit('addTariffClicked');
          this.mother_and_exchange_rate_disabled = true;
      },
      handleExchangeRateChanged(e){
          let value = e.target.value;
          if(value.includes(',')){
              value = value.replace(',', '.')
          }
          this.price_list_model.exchange_rate = this.money.localize(value, 4, 16);
          if(isNaN(value)){
              this.price_list_model.exchange_rate = '';
          }
      },
      showModal:function (){
          $('#add-tariff-modal').modal('show')
      },
      changeType: function ($event) {
        this.typeSelectEvent($event);
        this.setMinDateFrom();
      },
      changeCountry: function() {
        this.setMinDateFrom();
        this.$set(this.price_list_model, 'currency_id', '');
      },
      validationDuplicate : function (value, price_lists){
          if(this.action == 'create'){
              for (var i=0; i < price_lists.length; i++) {
                  if (price_lists[i].name === value
                      && price_lists[i].status !== 'archival'
                      && price_lists[i].id !== this.price_list_model.id) {
                      return price_lists[i];
                  }
              }
          }
          else{
              for (var i=0; i < price_lists.length; i++) {
                  if (price_lists[i].name === value
                      && price_lists[i].status !== 'archival') {
                      return price_lists[i];
                  }
              }
          }

      },

      setDatepickerValue : function () {
        return moment(this.value.date_from).format('YYYY-MM-DD');
      },
      validateForm() {
        this.$v.price_list_model.$touch();
      },
      setDateFrom(val) {
          this.$set(this.price_list_model, 'date_from', val);
          this.form_min_date = val;
      },
      destroyTariffs(){
          this.mother_and_exchange_rate_disabled = false;
          this.$emit('removeTariffClicked');
      },
      typeSelectEvent(type){
          if (this.action !='show' && this.action !='edit' && this.action != 'refill' && this.action !== 'copy') {
              if (type == 'standard') {
                  $('select[name=country]').prop("disabled", false);
                  $('input[name=name]').prop("disabled", true);

                  this.$set(this.price_list_model, 'name', '');
                  this.$set(this.price_list_model, 'currency_id', '');
                  this.$set(this.price_list_model, 'exchange_rate', '');
                  this.$set(this.price_list_model, 'mother_id', 0);
              } else if (type == 'special') {
                  this.$set(this.price_list_model, 'country_id', '');
                  this.$set(this.price_list_model, 'currency_id', '');
                  this.$set(this.price_list_model, 'exchange_rate', '')
                  this.$set(this.price_list_model, 'mother_id', 0);
                  this.form_min_date = new Date();
                  $('select[name=country]').prop("disabled", true);
                  $('input[name=name]').prop("disabled", false);

              }
              else if (type == 'mother'){
                  this.$set(this.price_list_model, 'currency_id', 'CSPoint');
                  $('input[name=name]').prop("disabled", false);
                  this.form_min_date = new Date();
                  this.$set(this.price_list_model, 'name', '');
              }
              else {
                  $('select[name=country]').prop("disabled", true);
                  $('input[name=name]').prop("disabled", true);
              }
          }
      },
      setMinDateFrom() {
          let filtered = this.price_lists;
          filtered = filtered.filter((i,n) => {
            return parseInt(i.country_id) == parseInt(this.price_list_model.country_id);
          });
          if (filtered.length > 0) {
              var form_min_date = new Date();
              for (var i = 0; i < filtered.length; i++) {
                if (Date.parse(form_min_date) < Date.parse(filtered[i].date_from)) {
                    form_min_date = filtered[i].date_from;
                }
              }
            var date = new Date(form_min_date);

            date.setDate(date.getDate() + 1);
            this.form_min_date = moment(date).format('YYYY-MM-DD');
          } else {
            this.form_min_date = moment().format('YYYY-MM-DD');
          }
          if (this.action != 'edit' && this.action != 'show') {
            this.setDateFrom(this.form_min_date)
            this.price_list_model.date_from = this.form_min_date;

          } else {
            this.form_min_date = this.price_list_model.date_from;
          }

      },
      getPriceLists () {
        const requestOptions = {
          method : "GET",
          headers: { "Content-Type": "application/json" }
        };
        fetch(this.route_price_list_index_json)
          .then(response => response.json())
          .then(data => {
            this.price_lists = data[0];
            this.setMinDateFrom()
          });
      },
      editableField () {
        return this.read_only == false && this.price_list.id != undefined;
      },
      isEmpty(value) {
          return Utils.isEmpty(value);
      }
  },
    mounted : function () {
      this.getPriceLists();
      this.price_list = {...this.value}
      this.price_list_model = {...this.value}

      this.country_select = this.$props.countries.map(function (item) {
          let country = new Object();
          country.id = item.id;
          country.text = item.country_name;
          return country;
      }),

      this.currency_select = this.$props.currencies.map(function (item) {
          let currency = new Object();
          currency.text = item.iso_code;
          currency.id = item.id;
          return currency;
      })
      this.typeSelectEvent(this.price_list.type);
      const date = new Date();
      date.setDate(date.getDate() + 1);
  }
}
</script>

<style lang="css">

.select2-container--default .select2-selection--single {
    border: 1px solid #c9ccd0 !important;
    border-radius: 0px !important;
	height: 30px !important;
}
.select2-container--default.select2-container--focus .select2-selection--single, .select2-container--default.select2-container--open.select2-container--below .select2-selection--single {
	border-color: #495966!important;
}
.select2-results__option {
    font-size: 11px !important;
}
.select2-container--default .select2-results__option--highlighted[aria-selected] {
    background-color: #1ab394;
}
</style>
